import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        paddingTop: 5,
        backgroundColor: theme.palette.background.paper,
    },
}));

export default useStyles;
